import React from "react";

const Label = props => {
	return (
		<div style={props.element.style}>{props.element.value}</div>
	);
};

export default React.memo(Label);
